
(function(){
    angular.module('tmx-app').controller('tradeRepositoryCtrl', [ '$mdDialog', '$state','TradeRepositoryService','LoanProductService',
        '$mdSidenav','resolvedData','tmxUtility','menu','tmxResource', 'TmxDialogService','ToastService','$filter','TMX_FINANCE_CONSTANTS',

        function TradeRepositoryCtrl($mdDialog, $state, TradeRepositoryService,LoanProductService, $mdSidenav,resolvedData,tmxUtility,menu,tmxResource,TmxDialogService,ToastService,$filter,TMX_FINANCE_CONSTANTS){
            
        //#region ------- Dev Notes ------------------

        //#endregion

        //#region --- Variable Declaration & Initialization--------
            var vm=this;
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            vm.checkPermission = tmxUtility.checkPermission;
            vm.formatDate = tmxUtility.formatDateForCompany;
            vm.formatDateTime = tmxUtility.formatDateTimeForCompany;
            vm.menu = menu;
            vm.gridData = new kendo.data.ObservableArray([]);
            vm.date = new Date().toJSON();
            vm.cols = TradeRepositoryService.filterColumn;
            vm.nav = "SearchSideNav";
            vm.schema = TradeRepositoryService.schema;
            vm.cloneColumn = TradeRepositoryService.gridColumn;
            vm.TradeRepositoryService = TradeRepositoryService;
            vm.TradeProducts=resolvedData.loanProducts.data;
            vm.userBanches = resolvedData.userBranches.data;
            vm.gridColumns=TradeRepositoryService.gridColumns;
            vm.Columns=TradeRepositoryService.cols;
            vm.gridColumns[0].template=formatApplicationName;

            vm.editPermission=tmxUtility.checkPermission('Private.Transaction.TradeRepository','Edit');
        //#endregion


        //#region ----- Local Functions-----------

            function formatApplicationName (item){
                var id=item.TransactionId;
        // ng-disabled="!TradeRepositoryCtrl.EditPrivilege"
                var template='<md-button class="tmx-primary-text-grid" ng-disabled="!TradeRepositoryCtrl.editPermission"  ng-click="TradeRepositoryCtrl.goToEditId('+id+')">'+item.TransactionNumber+'</md-button> <div class="margin-bottom-2"><span class="chip" ng-style={{dataItem.StatusBKColor}}> '+item.Status+ '</span></div>';
                return template;
            }            
            
            function InitializeGrid() {
                vm.filters = {};
                vm.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function(o){
                             
                                if(angular.isDefined(vm.searchClear) && vm.searchClear==false){
                                    if(exists(vm.o)){
                                        copy(vm.o.data,["filter"],o.data);
                                    }
                                }
                                vm.searchClear = false;
                                if(vm.onChildState()){return;}
                                if(!o.fromSideNav) {
                                    if($state.searchClear){
                                        vm.searchClear = true;
                                        $state.searchClear=undefined;
                                    }
                                }
                                else{
                                    o.data.firstPage = true;
                                }
    
    
                                vm.o = angular.copy(o);
                                vm.filters = vm.o.data.filter;
                                tmxResource("Transaction").getByParams(o,true).then(function(response){
                                    parseResppnse(response.data);
                                    vm.exportData=response;
                                    o.success(response);
                                });
                            },
    
                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },
    
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        sort:  [{field: "transactionId", dir: "desc"}]
                    },
                    excelExport: function(e) {                                         
                        var sheet = e.workbook.sheets[0];
                        var data = vm.exportData.data;
                        var gridColumns = vm.container.LoanApplicationGrid.columns;                    
                        var columns = tmxUtility.columnsMapping(gridColumns);                    
                        var rows=tmxUtility.dataMapping(data,columns); 
                        sheet.rows = rows;  
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: true,
                        pageSize: 10,
                        buttonCount: 5,
                    },
                    pdf: {
                        allPages: true,
                        fileName: "Trades.pdf"
                    },
                    excel: {
                  /*  allPages: true,*/
                        fileName: "Trades.xlsx"
                    },
    
                    sortable: true,
                    scrollable: false,
                    columns: vm.gridColumns
                };
                vm.searchSideNavActive=false;
                vm.container = {};//defining the object for grid access in controller
                $state.data= {
                    grid: vm.container,
                    mainGridOptions: angular.copy(vm.mainGridOptions)
                };
            }
            function PrepareLovs(){
                if(tmxUtility.exists(resolvedData.productTypesLkp)){
                    let tradeProductLkpIds = resolvedData.productTypesLkp.filter(x=>x.HiddenValue == TMX_FINANCE_CONSTANTS.LOOKUP_HV.TradeProduct).map(x=> x.LookupId);
                    vm.TradeProducts = vm.TradeProducts.filter(product =>  tradeProductLkpIds.includes(product.ProductTypeLkp));
                }
            }

            function parseResppnse(data){
                data.forEach(function(dataItem){                                                                            
                    dataItem.CustomerName= vm.formatCustomerName(dataItem.CustomerName);    
                    dataItem.NationalIdentifierValue=vm.formatCNICNumber(dataItem.NationalIdentifierValue);   
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);   
                    dataItem.CreatorName= vm.formatUser(dataItem.CreatorName);
                    dataItem.InboxName= vm.formatUser(dataItem.InboxName);
                    dataItem.formattedTransactionDate=vm.formatDate(dataItem.TransactionDate);
                });                
                
                vm.deletePermission=vm.checkEntityPermission("Delete");
                vm.assignPermission=vm.checkEntityPermission("Assign");
            }

        //#endregion

        //#region  -------- Scope Functions -----------
        
            
            vm.getMenu = function() {
                if(angular.isDefined(menu.pages.sections)){
                    for(var i=0;i<menu.pages.sections.length;i++){
                        var section = menu.pages.sections[i];
                        if(angular.isDefined(section.pages) && section.pages != null && section.pages.length>0){
                            for(var j=0;j<section.pages.length;j++){
                                if(section.pages[j].name ==  vm.EntityName){
                                    return section.pages[j];
                                }
                            }
                        }
                    }
                }
                return undefined;
            };

            vm.gotoAdd=function(product,branch){
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                var id=product;
                $state.go($state.current.name+".add",{Id:id,branch:branch,callbackState:$state.current.name});
            }

            vm.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            }

            vm.goToEdit=function(application){
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                var id=application.TransactionId;
                $state.go($state.current.name+".edit",{Id:id,callbackState:$state.current.name});
            }
            vm.goToEditId=function(id){
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{Id:id,callbackState:$state.current.name});
            }

            vm.checkEntityPermission = function(privilegeName) {
                return vm.checkPermission('Private.Transaction.TradeRepository',privilegeName);
            }

            vm.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };

            vm.clickDelete = function(item) {
                let messageText = 'Are you sure you want to cancel this Transaction?';
                let messageTitle = `Cancel Application ${item.TransactionNumber} ?`
                TmxDialogService.showConfirmDialog(messageTitle,messageText,deleteLoanApplication);
                function deleteLoanApplication() {
                    TradeRepositoryService.CancelById(item.TransactionId).then(function() {
                        $('#grid').data('kendoGrid').dataSource.read();
                    })
                }
            };
            vm.clickAdd = function () {
                $mdDialog.show({
                    controller: ['$mdDialog', '$scope', 'tmxUtility', 'products', 'branches', productSelectionController],
                    locals: {
                        products: vm.TradeProducts,
                        branches: vm.userBanches
                    },
                    templateUrl: 'app/private/transaction/product-selection-dialog.html',
                    clickOutsideToClose: false,
                    fullscreen: true

                }).then(function (returnData) {
                    if (!tmxUtility.exists(returnData)) {
                        return;
                    }
                    vm.gotoAdd(returnData.ProductId, returnData.BranchId);
                });
            }

            vm.clickAssign = function(item){

                LoanProductService.getStatesbyProduct(item.ProductId).then(function(response){

                    $mdDialog.show({
                        controller: ['$mdDialog','$scope','tmxUtility','lookupService','TMX_FINANCE_CONSTANTS', 'data','states',  assignController],
                        locals: {
                            data: item,
                            states: response.data
                        },
                        templateUrl: 'app/private/transaction/assign-dialog.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        fullscreen: true
                    }).then(function (returnData) { // After closing the dialog
                        if(!tmxUtility.exists(returnData)){
                            return;
                        }
                        let data = returnData;
                        data.PreviousStatusLkp = item.TransactionStatusLkp;
                        data.ProcessId = item.ProcessInstanceId;
                        data.ApplicationId = item.TransactionId;
                        TradeRepositoryService.setApplicationState(data).then(function(result){
                            if(result.data && result.status.code == "200"){
                                ToastService.showCustomToast("success", $filter('translate')("StateChangeSuccess"));
                                $('#grid').data('kendoGrid').dataSource.read();
                                return;
                            }
                            ToastService.showCustomToast("error", $filter('translate')("StateChangeError"));
                        });

                    }, function () {
    
                    });
                });
            }


//*******************KENDO*********************//            
            vm.isFiltered=function(fieldName){
                var filtered = false;
                if(angular.isDefined(vm.filters)) {
                    vm.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }
            vm.formatCustomerName=function(dataitem){
                return dataitem;
            };

            vm.formatString=function(value){
                if(!value) {
                    return "N/A";
                }
                else {
                    return value;
                }                        
            };

            vm.formatFullName=function(dataitem){
                return dataitem.FullName;
            };
            vm.formatCNICNumber=function(dataitem){
                if(!dataitem) return "";
                return dataitem;
            };     
            
            vm.formatUser=function(value){
                if(!value) {
                    return "";
                }
                else {
                    return value;
                }                        
            };     

            vm.toggleSearch=function(){
                if(vm.searchSideNavActive) {
                    vm.searchData = {};
                    vm.searchSideNavActive=false;
                }
                else
                    vm.searchSideNavActive=true;
                vm.toggle('SearchSideNav');
            }
            vm.exportSideNavActive=false;

            vm.toggleExport=function(){
                if(vm.exportSideNavActive)
                    vm.exportSideNavActive=false;
                else
                    vm.exportSideNavActive=true;
                vm.toggle('ExportSideNav');
            }

            vm.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };

            vm.search = function(navID) {

                let calls=[];
                for (var key in vm.searchData) {
                    if (vm.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: vm.searchData[key]
                        });
                    }
                }

                vm.filt = {
                    filters: calls,
                    logic: "and"
                };
                vm.o.data.filter = vm.filt;
                vm.container.LoanApplicationGrid.dataSource.transport.read(vm.o);

                vm.searchData = {};
                vm.toggle(navID);
            };

            vm.clear = function(navID) {
                vm.searchData = {};
                vm.toggle(navID);
            };
            //#endregion

            //#region  --Child Controllers-----

            function assignController($mdDialog,$scope, tmxUtility, lookupService, TMX_FINANCE_CONSTANTS, data,states) {

                $scope.availableStates = [];
                $scope.availableStatuses = [];
                $scope.data = data;
                $scope.showLoanEditableFields = false;

                $scope.ok = function(){

                    $scope.assignDialogCtrl.dialogForm.$submitted = true;
                    if(!$scope.assignDialogCtrl.dialogForm.$valid){
                        return;
                    }
                    let returnData = {
                        State:$scope.selectedState,
                        ApplicationStatusLkp: $scope.selectedStatus,
                        Comments: $scope.comments
                    }
                    $mdDialog.hide(returnData);
                }

                $scope.cancel = function(){
                    $mdDialog.hide();
                }

                function InitializeData(){
                    if(tmxUtility.exists(states) && states.length > 0){
                        $scope.availableStates = states.filter(x=>x.Name.trim() != "")
                            .map(x=> ({
                                HiddenValue : x.Name,
                                VisibleValue: x.VisibleName
                            }));
                    }

                    $scope.availableStatuses = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.APPLICATION_STATUS);
                    
                    $scope.availableStates = tmxUtility.orderArrayByProperty($scope.availableStates ,['VisibleValue'],['asc']);
                    $scope.availableStatuses = tmxUtility.orderArrayByProperty($scope.availableStatuses ,['VisibleValue'],['asc']);

                }

                (function InitializePage(){
                    InitializeData();
                    PrepareLovs();
                })();
            }
            function productSelectionController($mdDialog, $scope, tmxUtility, products, branches) {
                $scope.availableProducts = [];
                $scope.userBranches = [];
                $scope.disableBranchSelection = false;


                $scope.ok = function () {

                    $scope.productSelectionCtrl.dialogForm.$submitted = true;
                    if (!$scope.productSelectionCtrl.dialogForm.$valid) {
                        return;
                    }
                    let returnData = {
                        ProductId: $scope.selectedProduct,
                        BranchId: $scope.selectedBranch
                    }
                    $mdDialog.hide(returnData);
                }

                $scope.cancel = function () {
                    $mdDialog.hide();
                }

                function InitializeData() {
                    $scope.availableProducts = products.map(x => ({ LookupId: x.ProductId, VisibleValue: x.ProductName }));
                    if (tmxUtility.exists(branches)) {
                        $scope.userBranches = branches.map(x => ({ LookupId: x.CompanyBranchId, VisibleValue: x.BranchName }));
                        if ($scope.userBranches.length == 1) { // If there is only one branch associated, then by default make it selected and disabled
                            $scope.selectedBranch = $scope.userBranches[0].LookupId;
                            $scope.disableBranchSelection = true;
                        }
                    }
                }

                (function InitializeDialog() {
                    InitializeData();
                })();
            }
            //#endregion

            
            // eslint-disable-next-line no-unexpected-multiline
            (function InitializePage(){
                InitializeGrid();
            })();
            
        }
    ]);
})();

